<template>
  <ProSpaceGeoLayout>
    <template #top>
      <ProSpaceTopPanel :header="this.$t('hSRs')">
        <template #right>
          <ProSpaceIconButton
            icon="update"
            iconWidth="16px"
            iconHeight="16px"
            containerSize="20px"
            @click="actionUpdate"
          />
          <ProSpaceDots
            style="margin-left: 15px"
            :options="dotsHeaderOptions"
            :isSquare="true"
            @action="(action) => handleHeaderDots(action)"
          />
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout>
        <template #top>
          <ProSpaceFilterPanel
            :searchPlaceholder="$t('searchTxt')"
            :modelFastFilter="modelFastFilter"
            :fastFilters="fastFilters"
            :txtResetFilters="$t('txtResetFilters')"
            @apply="submitFilter"
            ref="filter-panel"
            :filter-model="['value', 'code']"
            @update:modelFastFilter="
              (val) => {
                modelFastFilter = val;
                clear();
              }
            "
          >
            <template #hint>
              {{ this.$t("filterBy") }}
            </template>
            <template #filters="{ filter }">
              <ProSpaceCustomFilterPanel
                :customTxt="$t('custom')"
                :customFilterTxt="$t('customFilterTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('resetTxt')"
                :fromTxt="$t('fromTxt')"
                :toTxt="$t('toTxt')"
                :services="customServices"
                @apply="(model) => customFilterApply(filter, model)"
              />
            </template>
          </ProSpaceFilterPanel>
        </template>
        <template #center>
          <ProSpaceMainGrid
            ref="grid"
            :service="hSRService"
            @selected-change="selectedHandler"
            @db-click="toItem"
            :noMountedRequest="true"
            getMethod="grid"
            selectionMode="single"
          >
            <template #columns>
              <Column field="code" :header="$t('code')" sortable>
                <template #body="field">
                  <ProSpaceTag
                    v-if="field.data"
                    :text="field.data.code"
                    type="gray-light"
                    bordered
                  />
                </template>
              </Column>
              <Column field="value" :header="$t('hSRValue')" sortable>
                <template #body="field">
                  <ProSpaceDefaultTextColumn>
                    {{ field.data.value }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>
              <Column field="actions" class="column-end column-end-30">
                <template #body="field">
                  <ProSpaceDots
                    v-if="field.data"
                    :options="wrapperCheckRoles(dotsOptions, field.data)"
                    @action="(action) => handleDots(action, field.data)"
                  ></ProSpaceDots>
                </template>
              </Column>
            </template>
            <template #empty>
              <ProSpaceEmptyGrid
                icon="error-message"
                :title="$t('noDataTitle')"
                :text="$t('noDataTxt')"
              />
            </template>
          </ProSpaceMainGrid>
        </template>
      </ProSpaceGeoLayout>
      <ProSpaceModal
        v-model="showModal"
        width="410"
        :disabledApply="false"
        :title="isEdit ? $t('editItemTxt') : $t('createItemTxt')"
        :icon="isEdit ? 'edit' : 'plus'"
        @apply="changeItem"
        :cancelTxt="$t('cancelTxt')"
        :applyTxt="$t('applyTxt')"
      >
        <ProSpaceVLayout :gap="20">
          <ProSpaceInputText
            v-model="modalModel.value"
            :label="$t('hSRValue')"
            :placeholder="$t('hSRValue')"
          />
        </ProSpaceVLayout>
      </ProSpaceModal>
      <HSRModalImport
        v-model="showImportModal"
        @loading="loadingHandler"
        accept=".csv, .xlsx"
      />
      <ProSpaceHistoryModal
        ref="history"
        v-model="showHistoryModal"
        modelName="HSRApiModel"
        @close="closeHistory"
      />
    </template>
    <template #right>
      <HSRPanel
        v-if="selectedModel.length > 0"
        ref="right-panel"
        :service="hSRService"
        :ids="selectedModel"
        :options="dotsOptions"
        :filterAccessDots="wrapperCheckRoles"
        :checkEditAccess="checkFormAccess"
        :checkAccess="checkAccess"
        @clear="clear"
        @edit="editItem"
        @delete="deleteItem"
        @history="showHistory"
      />
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceFilterPanel,
  ProSpaceCustomFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceMainGrid,
  ProSpaceDots,
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceIconButton,
  ProSpaceButton,
  ProSpaceTableHeaderCell,
  ProSpaceDateColumn,
  ProSpaceDefaultTextColumn,
  ProSpaceEmptyGrid,
  ProSpaceLeftPanel,
  ProSpaceTree,
  ProSpaceVLayout,
  ProSpaceFilterContainsChips,
  ProSpaceFilterDatesRange,
  ProSpaceDropdown,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceInputSwitch,
  ProSpaceInputText,
  ProSpaceTag,
} from "@prospace/prospace-components-library";
import { HSRService } from "../../services/HSRService.js";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import Column from "primevue/column";
import HSRPanel from "./components/HSRPanel";
import ProSpaceHistoryModal from "../../../../../Frontends/ProSpace/components/modals/ProSpaceHistoryModal.vue";
import HSRModalImport from "./components/HSRModalImport";
const _ = require("lodash");
import { mapGetters } from "vuex";
export default {
  mixins: [accessMixin],
  components: {
    ProSpaceFilterPanel,
    ProSpaceCustomFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceMainGrid,
    ProSpaceDots,
    ProSpaceModal,
    Column,
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceIconButton,
    ProSpaceButton,
    ProSpaceTableHeaderCell,
    ProSpaceDateColumn,
    ProSpaceDefaultTextColumn,
    ProSpaceEmptyGrid,
    HSRPanel,
    ProSpaceHistoryModal,
    ProSpaceLeftPanel,
    ProSpaceTree,
    ProSpaceVLayout,
    ProSpaceFilterContainsChips,
    ProSpaceFilterDatesRange,
    ProSpaceDropdown,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceInputSwitch,
    ProSpaceInputText,
    HSRModalImport,
    ProSpaceTag,
  },
  data() {
    return {
      showModal: false,
      showImportModal: false,
      showHistoryModal: false,
      // Grid Panel
      selectedModel: [],
      spKey: 0,
      spHide: false,

      // Service
      hSRService: new HSRService(),

      //InlinePanel
      masterId: null,
      isEdit: false,
      isCreate: false,
      modalModel: {},

      // Multi filter
      modelFastFilter: {
        label: this.$t("allTxt"),
        value: false,
        field: "disabled",
      },
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      access: "securityRoleAccess/access",
    }),
    customServices() {
      let filters = [
        {
          type: "chips",
          model: "code",
          label: this.$t("code"),
          selected: {},
          placeholder: this.$t("code"),
        },
      ];
      if (this.checkAccess("metainfo-by-block"))
        filters.push(
          {
            type: "chips",
            model: "createdBy",
            label: this.$t("createdByTxt"),
            selected: {},
          },
          {
            type: "chips",
            model: "updatedBy",
            label: this.$t("updatedByTxt"),
            selected: {},
          }
        );
      filters.push(
        {
          type: "dates-range-time",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
          labelFrom: this.$t("fromTxt"),
          labelTo: this.$t("toTxt"),
        },
        {
          type: "dates-range-time",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
          labelFrom: this.$t("fromTxt"),
          labelTo: this.$t("toTxt"),
        }
      );
      return filters;
    },
    dotsHeaderOptions() {
      let dots = [
        { name: "export_xlsx", text: this.$t("export_xlsx"), icon: "download" },
      ];
      if (this.checkAccess("import-option")) {
        dots.push({
          name: "import",
          text: this.$t("import"),
          icon: "upload",
        });
      }
      return dots;
    },
    dotsOptions() {
      let del = {
        name: "delete",
        text: this.$t("delete"),
        icon: "delete",
        method: this.deleteItem,
        liteRef: "delete-option",
      };
      let res = [
        {
          name: "edit",
          text: this.$t("editItemTxt"),
          icon: "edit",
          method: this.editItem,
          liteRef: "edit-option",
        },
        {
          name: "showHistory",
          text: this.$t("history"),
          icon: "history",
          method: this.showHistory,
          liteRef: "history-option",
        },
      ];
      if (this.modelFastFilter.label != this.$t("deleted")) {
        res.splice(1, 0, del);
      }
      return res;
    },
    fastFilters() {
      let filters = [{ label: this.$t("allTxt"), field: "disabled", value: false }];

      if (this.checkDeleteAccess())
        filters.push({ label: this.$t("deleted"), field: "disabled", value: true });

      return filters;
    },
  },
  methods: {
    closeHistory() {
      this.showHistoryModal = false;
    },
    showHistory(record) {
      this.$refs.history.tabs[0].masterId = record.id;
      this.$refs.history.masterName = record.code;
      this.$nextTick(() => {
        this.showHistoryModal = true;
      });
    },
    toItem(data) {
      this.$router.push(`/addressprogram/hsr/${data.id}`);
    },
    submitFilter({ filter, search }) {
      this.$refs.grid.submitFilter(filter, search);
    },
    emitFilter() {
      this.$refs["filter-panel"].submitFilter();
    },
    customFilterApply(filter, model) {
      filter = Object.assign(filter, model);
      this.$refs["filter-panel"].submitFilter();
    },
    actionUpdate() {
      this.$refs.grid.getRecords(true);
      if (this.$refs["right-panel"]) {
        this.$refs["right-panel"].update();
      }
    },
    actionExport(format) {
      this.loadingHandler(true);
      this.hSRService
        .export(this.$refs.grid.getRecords(false, true), format)
        .then(() => this.loadingHandler(false));
      //TODO: Catch error?
      //TODO: Show message(export task created)
    },
    actionImport() {
      this.showImportModal = true;
    },
    loadingHandler(val) {
      this.$refs.grid.loading = val;
    },
    selectedHandler({ data }) {
      this.selectedModel = [data.id];
    },
    spToggle() {
      this.spHide = !this.spHide;
    },
    showChangeModal() {
      this.isEdit = false;
      this.isCreate = true;
      this.modalModel = {};
      this.showModal = true;
    },
    clear() {
      this.selectedModel = {};
      this.$refs.grid.selectedModel = [];
    },
    editItem(model) {
      if (!model) return;
      this.isEdit = true;
      this.isCreate = false;
      this.modalModel = _.cloneDeep(model);
      this.showModal = true;
    },
    changeItem() {
      let method;
      if (this.isCreate) {
        method = "create";
      }
      if (this.isEdit) {
        method = "update";
      }
      this.hSRService[method](this.modalModel).then(() => {
        this.actionUpdate();
      });
    },
    deleteItem(model) {
      if (!model) return;
      this.hSRService.delete(model).then(() => {
        this.actionUpdate();
        this.selectedModel = {};
      });
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    handleDots(action, item) {
      var option = this.dotsOptions.find((o) => o.name === action);
      option.method(item);
    },
    handleHeaderDots(action) {
      switch (action) {
        case "import":
          this.actionImport();
          break;
        case "export_csv":
          this.actionExport("CSV");
          break;
        case "export_xlsx":
          this.actionExport("XLSX");
          break;
      }
    },
  },
};
</script>
<style lang="scss"></style>
